export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/industrial_product_design.4bd1b3d.svg";